import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { socketConnection } from "../../../services/socket";
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from '../../../context/Auth/AuthContext';
import { SocketContext } from '../../../context/Socket/SocketContext';
import { Box, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2)
  },
  section: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1)
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    color: theme.palette.primary.main
  },
  qrCodeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  barcodeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  },
  copyButton: {
    textTransform: 'none',
    marginTop: theme.spacing(1)
  },
  infoText: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5
  },
  barcodeText: {
    fontFamily: 'monospace',
    fontSize: '0.85rem',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(0.5),
    wordBreak: 'break-all',
    textAlign: 'center',
    width: '100%'
  }
}));

function CheckoutSuccess(props) {

  const { pix } = props;
  const classes = useStyles();
  const socketManager = useContext(SocketContext);
  const [pixString,] = useState(pix?.qrcode?.qrcode || pix?.qrcode?.copyPaste || '');
  const [asaasPixQR,] = useState(pix?.qrcode?.qrcode || '');
  const [asaasPixCopyPaste,] = useState(pix?.qrcode?.copyPaste || '');
  const [stripeURL,] = useState(pix.stripeURL);
  const [asaasBoletoLink,] = useState(pix?.boleto?.link || '');
  const [asaasBoletoBarcode,] = useState(pix?.boleto?.barcode || '');
  const [asaasURL,] = useState(pix.asaasURL);
  const [mercadopagoURL,] = useState(pix.mercadopagoURL);
  const [valorext,] = useState(pix.valorext);
  const [paymentMethod,] = useState(pix.paymentMethod);
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  const { dateToClient } = useDate();
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  useEffect(() => {
    const onCompanyPayment = (data) => {
      if (data.action === "CONCLUIDA") {
        toast.success(`Sua licença foi renovada até ${dateToClient(data.company.dueDate)}!`);
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    }
    socket.on(`company-${companyId}-payment`, onCompanyPayment);
    
    return () => {
      socket.disconnect();
    }
  }, [history, dateToClient, socketManager]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  return (
    <React.Fragment>
      <Total>
        <p><span>TOTAL</span></p>
        <strong>R$ {valorext.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</strong>
      </Total>

      <SuccessContent className={classes.container}>
  
        {/* ASAAS PIX */}
        {paymentMethod === 'pix' && (asaasPixQR || asaasPixCopyPaste) && (
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>
              💳 Pagamento via PIX
            </Typography>
            <Box className={classes.qrCodeContainer}>
              {asaasPixQR && (
                <>
                  <QRCode value={asaasPixQR} size={256} />
                  <CopyToClipboard text={asaasPixQR} onCopy={handleCopyQR}>
                    <Button 
                      variant="outlined" 
                      color="primary"
                      className={classes.copyButton}
                      startIcon={copied ? <FaCheckCircle /> : <FaCopy />}
                    >
                      {copied ? 'Copiado!' : 'Copiar QR Code'}
                    </Button>
                  </CopyToClipboard>
                </>
              )}
              {asaasPixCopyPaste && (
                <>
                  <Typography className={classes.infoText} align="center">
                    Ou copie e cole este código PIX:
                  </Typography>
                  <Typography className={classes.barcodeText}>
                    {asaasPixCopyPaste}
                  </Typography>
                  <CopyToClipboard text={asaasPixCopyPaste} onCopy={handleCopyQR}>
                    <Button 
                      variant="outlined" 
                      color="primary"
                      className={classes.copyButton}
                      startIcon={copied ? <FaCheckCircle /> : <FaCopy />}
                    >
                      {copied ? 'Copiado!' : 'Copiar Código PIX'}
                    </Button>
                  </CopyToClipboard>
                </>
              )}
              <Typography className={classes.infoText} align="center">
                Escaneie o QR Code com seu banco ou use o código PIX para completar o pagamento.
              </Typography>
            </Box>
          </Box>
        )}

        {/* GERENCIANET PIX (fallback/legacy) */}
        {paymentMethod === 'pix' && pixString && !asaasPixQR && (
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>
              💳 Pagamento via PIX
            </Typography>
            <Box className={classes.qrCodeContainer}>
              <QRCode value={pixString} size={256} />
              <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
                <Button 
                  variant="outlined" 
                  color="primary"
                  className={classes.copyButton}
                  startIcon={copied ? <FaCheckCircle /> : <FaCopy />}
                >
                  {copied ? 'Copiado!' : 'Copiar Código PIX'}
                </Button>
              </CopyToClipboard>
              <Typography className={classes.infoText} align="center">
                Para finalizar, basta realizar o pagamento escaneando ou colando o código PIX acima.
              </Typography>
            </Box>
          </Box>
        )}

        {/* ASAAS BOLETO */}
        {paymentMethod === 'boleto' && (asaasBoletoLink || asaasBoletoBarcode) && (
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>
              📄 Pagamento via Boleto
            </Typography>
            <Box className={classes.barcodeContainer}>
              {asaasBoletoBarcode && (
                <>
                  <Typography className={classes.infoText} align="center">
                    Código de Barras:
                  </Typography>
                  <Typography className={classes.barcodeText}>
                    {asaasBoletoBarcode}
                  </Typography>
                  <CopyToClipboard text={asaasBoletoBarcode} onCopy={handleCopyQR}>
                    <Button 
                      variant="outlined" 
                      color="primary"
                      className={classes.copyButton}
                      startIcon={copied ? <FaCheckCircle /> : <FaCopy />}
                    >
                      {copied ? 'Copiado!' : 'Copiar Código de Barras'}
                    </Button>
                  </CopyToClipboard>
                </>
              )}
              {asaasBoletoLink && (
                <>
                  <Button 
                    onClick={() => window.open(asaasBoletoLink, '_blank')} 
                    variant="contained" 
                    color="primary"
                    fullWidth
                  >
                    Abrir Boleto
                  </Button>
                  <Typography className={classes.infoText} align="center">
                    Clique no botão acima para visualizar e imprimir o boleto. Você pode pagar em qualquer banco.
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        )}

        {/* STRIPE */}
        {stripeURL && (
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>
              💳 Pagamento com Cartão de Crédito
            </Typography>
            <Button 
              onClick={() => window.open(stripeURL, '_blank')} 
              variant="contained"
              color="primary"
              fullWidth
            >
              Pagar com Stripe
            </Button>
          </Box>
        )}
        
        {/* MERCADO PAGO */}
        {mercadopagoURL && (
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>
              💳 Pagamento com MercadoPago
            </Typography>
            <Button 
              onClick={() => window.open(mercadopagoURL, '_blank')} 
              variant="contained"
              color="primary"
              fullWidth
            >
              Pagar com MercadoPago
            </Button>
          </Box>
        )}
        
        {/* ASAAS Generic */}
        {asaasURL && paymentMethod !== 'pix' && paymentMethod !== 'boleto' && (
          <Box className={classes.section}>
            <Typography className={classes.sectionTitle}>
              💳 Ir para Pagamento
            </Typography>
            <Button 
              onClick={() => window.open(asaasURL, '_blank')} 
              variant="contained"
              color="primary"
              fullWidth
            >
              Pagar com ASAAS
            </Button>
          </Box>
        )}
        
      </SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
